import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/YALWAS_LOGO-removebg-preview (2).png';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      <nav style={{backgroundColor:'#0C64C3'}} className="Comfortaa  flex flex-wrap items-center justify-between w-full py-4 md:py-0 px-4 text-md text-gray-700 bg-white">
        <div>
          <Link to="/">
            <img src={logo} alt="logo" className="w-50 h-10" />
          </Link>
        </div>
       { menuOpen ? (
        <svg
    xmlns="http://www.w3.org/2000/svg"
    onClick={toggleMenu}
    className="h-6 w-6 cursor-pointer md:hidden block"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="#ffffff"
      >
    <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"/>
  </svg>

 
) : (


  <svg
  xmlns="http://www.w3.org/2000/svg"
  onClick={toggleMenu}
  className="h-6 w-6 cursor-pointer md:hidden block"
  viewBox="0 0 24 24"
  stroke="#ffffff" 
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M4 6h16M4 12h16M4 18h16" />
</svg>

)}
        <div
          className={`w-full md:flex md:items-center md:w-auto ${
            menuOpen ? '' : 'hidden'
          }`}
        >
          <ul className="pt-4 text-center md:flex md:justify-between md:pt-0">
            <li>
              <Link
                to="/"
                className="text-white md:p-4 py-2 block  hover:text-[#D8D9DA]"
              >
                Acceuil
              </Link>
            </li>
            <li>
              <Link
                to="/Services"
                className="text-white md:p-4 py-2 block hover:text-[#D8D9DA]"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/About-Us"
                className="text-white md:p-4 py-2 block hover:text-[#D8D9DA]"
              >
                About Us
              </Link>
            </li>
           
            <li>
              <Link
                to="/Contact-Us"
                className="text-white md:p-4 py-2 block hover:text-[#D8D9DA]"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
